/** Ensures E.164-style dial codes start with `+`; empty/whitespace stays empty. */
export const normalizeDialCode = (value: string | undefined): string => {
  const trimmed = (value ?? '').trim();
  if (!trimmed) {
    return '';
  }
  return trimmed.startsWith('+') ? trimmed : `+${trimmed}`;
};
